import React from "react";
import "./DatabaseSelector.css";

export const DatabaseSelectorSkeleton = ({ variant = "compact" }) => (
  <div className={`database-selector ${variant} database-selector-skeleton`}>
    <span className="db-selector-skeleton-label" />
    <span className="database-selector-skeleton-control" />
  </div>
);

const DatabaseSelector = ({
  databases = [],
  selectedDatabaseId,
  onChange,
  labelPrefix,
  variant = "compact",
  className = "",
}) => {
  const hasDatabases = Array.isArray(databases) && databases.length > 0;
  const selectValue =
    selectedDatabaseId === null || selectedDatabaseId === undefined
      ? ""
      : String(selectedDatabaseId);

  const handleSelect = (event) => {
    const nextValue = event.target.value;
    const matchedDb = databases.find((db) => String(db.id) === nextValue);
    onChange?.(matchedDb ? matchedDb.id : null);
  };

  return (
    <div className={`database-selector ${variant} ${className}`.trim()}>
      {labelPrefix ? <span className="database-selector-label">{labelPrefix}</span> : null}
      <select
        className="database-selector-control"
        value={selectValue}
        onChange={handleSelect}
        disabled={!hasDatabases}
        aria-label="Select database"
      >
        {!hasDatabases ? (
          <option value="">No databases</option>
        ) : (
          databases.map((db) => (
            <option key={db.id} value={String(db.id)}>
              {db.generic_name || db.display_label || db.name}
            </option>
          ))
        )}
      </select>
    </div>
  );
};

export default DatabaseSelector;
